import React, { useCallback } from 'react'
import {
  Row,
  Col,
  Popover,
  PopoverHeader,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
  NavItem,
  NavLink
} from 'reactstrap'
import { graphql, compose } from 'react-apollo'
import { QueryOutagesCheck } from '~/queries/outage.gql'
import useToggle from '~/hooks/useToggle'
import { dataUnready } from '~/lib/helpers/dataUnready'

function OutageNotifications ({ data }) {
  const [outageOpen, toggleOutage] = useToggle()
  const { unready, outages } = dataUnready(data, 'outages')
  let outageResults = null

  // For popover "legacy" toggle, only close if not mobile view
  const toggleOutagePopover = useCallback(() => {
    if (window.matchMedia('(min-width: 768px)').matches) {
      toggleOutage()
    }
  }, [])

  if (unready || !outages.length) {
    return null
  } else {
    outageResults = (
      <PopoverBody className='p-0'>
        {outages.map(outage => (
          <Row key={outage.id} className='h-100 border-top py-3 m-auto align-items-center text-left font-weight-semibold'>
            <Col>
              {outage.message}
            </Col>
          </Row>
        ))}
      </PopoverBody>
    )

    return (
      <>
        <NavItem>
          <NavLink id='topnav-outages-popover' onClick={toggleOutage}>
            <i className='fa fa-info-outline text-warning' />
          </NavLink>
        </NavItem>
        <Popover
          className='popover-notifications p-0 d-none d-md-block'
          placement='bottom'
          trigger='legacy'
          delay={0}
          isOpen={outageOpen}
          target='topnav-outages-popover'
          toggle={toggleOutagePopover}
          fade={false}
        >
          <PopoverHeader className='border-bottom-0'>Outages</PopoverHeader>
          {outageResults}
        </Popover>

        <Modal
          isOpen={outageOpen}
          toggle={toggleOutage}
          modalClassName='d-md-none'
          backdropClassName='d-md-none'
          modalTransition={{ timeout: 0 }}
          backdropTransition={{ timeout: 0 }}
        >
          <ModalHeader tag='h2' close={<i className='close fa fa-close cursor-pointer' onClick={toggleOutage} />}>
          Outages
          </ModalHeader>
          <ModalBody className='p-0'>
            <div className='border-bottom'>
              {outageResults}
            </div>
          </ModalBody>
        </Modal>
      </>
    )
  }
}

const withOutages = graphql(QueryOutagesCheck, {
  options: () => ({
    ssr: false,
    fetchPolicy: 'cache-and-network',
    pollInterval: 900000,
    variables: {
      check: []
    }
  })
})

export default compose(
  withOutages
)(OutageNotifications)
